module.exports = "/_next/static/images/3-21ffa230e6d5804a72e662a1b173b9a1.png";